export default (websiteId: string, dialogId: string): string => {
    return `website/${websiteId}/${dialogId}/`;
};
